import { NgModule } from '@angular/core';
import {FormatCurrencyPipe} from './format-currency.pipe';
import {CoreMapPipe} from './map.pipe';
import {SearchPipe} from './search.pipe';
import {NgArrayPipesModule} from '@shared/pipes/array';
import {NgStringPipesModule} from '@shared/pipes/string';
import {NgMathPipesModule} from '@shared/pipes/math';
import {NgBooleanPipesModule} from '@shared/pipes/boolean';
import {NgObjectPipesModule} from '@shared/pipes/object';
import {NgDatePipesModule} from '@shared/pipes/date';
import {NgGenericPipeModule} from '@shared/pipes/generic/ng-generic-pipe.module';
import {TableFiledPipe} from '@shared/pipes/table/table-filed.pipe';
import {HighlightSearch} from '@shared/pipes/high-light.pipe';

const PIPES = [FormatCurrencyPipe, CoreMapPipe, SearchPipe,TableFiledPipe, HighlightSearch]

@NgModule({
  exports: [
    ...PIPES,
    NgArrayPipesModule,
    NgStringPipesModule,
    NgMathPipesModule,
    NgBooleanPipesModule,
    NgObjectPipesModule,
    NgDatePipesModule,
    NgGenericPipeModule
  ],

  declarations: [
    ...PIPES
  ]
})
export class PipesModule { }

export * from './format-currency.pipe';
export * from './map.pipe';
export * from './search.pipe';
export * from './array/index';
export * from './object/index';
export * from './string/index';
export * from './math/index';
export * from './boolean/index';
export * from './date/index';
